export const GridParams = {
  NUM_COLUMNS: 6,
  MAX_HEIGHT: 4,
  MAX_WIDTH: 6,
  WIDGET_MARGIN: 10
};